import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { FontAccessibilityProvider } from './context/FontAccessibilityContext';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import HomePage from './Pages/HomePage';
import About from './Pages/About';
import IntroductionPage from './Pages/Introduction';
import Repositories from './Pages/Repositories';
import Aram from './Pages/Aram';
import Porul from './Pages/Porul';
import Inbam from './Pages/Inbam';
import Features from './Pages/Features';
import FindBranches from './Pages/FindBranches';
import AboutUs from './Pages/AboutUs';
import Pds from './Pages/Pds';
import Dccws from './Pages/Dccws';
import Mudhalvar from './Pages/Mudhalvar';
import QuickCommerce from './Pages/QuickCommerce';
import Thayumanavar from './Pages/Thayumanavar';
import Kcc from './Pages/Kcc';
import Tnsc from './Pages/Tnsc';
import Dccb from './Pages/Dccb';
import Kooturavu from './Pages/Kooturavu';
import Amma from './Pages/Amma';
import Ucb from './Pages/Ucb';
import Agri from './Pages/Agri';
import Paccs from './Pages/Paccs';
import Agrimarketing from './Pages/Agrimarketing';
import Society from './Pages/Society';
import Loan from './Pages/Loan';
import Auto from './Pages/Auto';
import Dccwss from './Pages/Dccwss';

const AppRoutes = () => {
  const location = useLocation();

  return (
    <div className="App flex flex-col min-h-screen">
      <Navbar />

      {/* IMPORTANT: Added id="main-content" here for font accessibility */}
      <main id="main-content" className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/dccws" element={<Dccws />} />
          <Route path="/pds" element={<Pds />} />
          <Route path="/quick-commerce" element={<QuickCommerce />} />
          <Route path="/mudhalvar" element={<Mudhalvar />} />
          <Route path="/thayumanavar" element={<Thayumanavar />} />
          <Route path="/kcc" element={<Kcc />} />
          <Route path="/tnsc" element={<Tnsc />} />
          <Route path="/dccb" element={<Dccb />} />
              <Route path="/Paccs" element={<Paccs />} />
                            <Route path="/agri-marketing" element={<Agrimarketing />} />
                                             <Route path="/Dccwss" element={<Dccwss />} />
                                    <Route path="/society-registration" element={<Society />} />
                                        <Route path="/loan" element={<Loan/>} />
                                               <Route path="/auto" element={<Auto />} />
          <Route path="/kooturavu-marundhagam" element={<Kooturavu />} />
          <Route path="/amma-marundhagam" element={<Amma />} />
          <Route path="/ucb" element={<Ucb />} />
          <Route path="/agri-mechanism" element={<Agri />} />
          <Route path="/repositories" element={<Repositories />} />
          <Route path="/section1" element={<Aram />} />
          <Route path="/section2" element={<Porul />} />
          <Route path="/section3" element={<Inbam />} />
          <Route path="/aram" element={<Aram />} />
          <Route path="/porul" element={<Porul />} />
          <Route path="/inbam" element={<Inbam />} />
          <Route path="/sections" element={<IntroductionPage />} />
          <Route path="/findourbranches" element={<FindBranches />} />
          <Route path="/features" element={<Features />} />
          {/* Add screen reader route when ready */}
          {/* <Route path="/screen-reader" element={<ScreenReaderAccess />} /> */}
        </Routes>

        {location.pathname === '/' && <IntroductionPage />}
      </main>

      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <LanguageProvider>
        <FontAccessibilityProvider>
          <AppRoutes />
        </FontAccessibilityProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;